import gql from 'graphql-tag';

const findListsByIdsGql = gql`
  query (
    $instId: String!
    $accountId: String!
    $size: Int!
    $listIds: [String]
  ) {
    paginatedList(
      instId: $instId
      accountId: $accountId
      size: $size
      listIds: $listIds
    ) {
      list {
        value: id
        label: name
      }
    }
  }
`;
export default findListsByIdsGql;
